import { CallStateEnum } from '@models/call-state.model.ts';

export const callStateStatusSlice = (set: any, getState: any) => ({
  isGenreLoading: () => getState().genreCallState === CallStateEnum.Loading,
  isGenreLoaded: () => getState().genreCallState === CallStateEnum.Loaded,
  isGenreError: () => getState().genreCallState === CallStateEnum.Error,
  isSeasonLoading: () => getState().seasonCallState === CallStateEnum.Loading,
  isSeasonLoaded: () => getState().seasonCallState === CallStateEnum.Loaded,
  isSeasonError: () => getState().seasonCallState === CallStateEnum.Error,
  isEpisodeLoading: () => getState().episodeCallState === CallStateEnum.Loading
});
